<template>
  <!-- Modal terms -->
  <div
    class="modal fade"
    id="promotion-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="promotionModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="promotionModal">{{ $t('Promosyon header') }}</h4>
          <button id="modalClose" type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <p>{{ $t('Promosyon text') }}</p>
          <form @submit.prevent="apply(code)">
            <InputField
              v-model="code"
              name="promotion_code"
              class="required"
              v-validate="'required'"
              :placeholder="$t('Promosyon placeholder')"
              :error="errors.first('promotion_code')"
              errorBox="promotion_code"
              :validateFields="fields['promotion_code']"
            />
            <div class="form-group">
              <div class="text-right">
                <button type="submit" class="btn_1">{{ $t('Uygula') }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
import payment from './../../stores/payment.js';
import InputField from './../InputField.vue';

export default {
  name: 'PromotionModal',
  props: ['companyType', 'promotionCodes', 'form', 'isHaveCustomEndpoint'],
  components: {
    InputField,
  },
  data() {
    return {
      code: null,
      promotions: [],
    };
  },
  methods: {
    closeModal() {
      document.getElementById('modalClose').click();
    },
    apply(code) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.applyCode(code);
        }
      });
    },
    async applyCode(code) {
      if (!Array.isArray(code)) {
        const obj = this.promotionCodes.includes(code);
        if (obj) {
          window.Vue.$toasted.error(this.$t('AlertMessages.Girdiğiniz promosyonu daha önceden kullandınız'));
          return;
        } else {
          this.promotions = [...this.promotionCodes];
          this.promotions.push(code);
        }
      } else {
        const checkIsAlreadyApplied = code.filter((element) => this.promotionCodes.includes(element));
        if (checkIsAlreadyApplied.length) {
          window.Vue.$toasted.error(this.$t('AlertMessages.Girdiğiniz promosyonu daha önceden kullandınız'));
          return;
        }
        this.promotions = [...this.promotionCodes, ...code];
      }

      this.closeModal();
      if (this.isHaveCustomEndpoint) {
        this.$emit('custom-apply-promotion-clicked', code);
      } else {
        await payment
          .dispatch('multiplePromotionAppliable', {
            productId: this.form.product_id,
            promotions: this.promotions,
            companyTypeId: this.companyType.id,
          })
          .then((s) => {
            if (!Array.isArray(code)) {
              this.promotionCodes.push(code);
            } else {
              code.forEach((code) => {
                this.promotionCodes.push(code);
              });
              this.promotions = [...this.promotionCodes, ...code];
            }
            this.$emit('promotion', s.data.data);

            this.code = null;
          })
          .finally(() => {
            return true;
          });
      }
    },
  },
};
</script>
